import { FunctionComponent, useEffect } from 'react';

export const Modal: FunctionComponent<{
	disableEscDismiss?: boolean;
	topOffset?: number;
	onClose?(): void;
}> = ({ children, disableEscDismiss = false, topOffset = 0, onClose }) => {
	useEffect(() => {
		if (disableEscDismiss) {
			return () => {};
		}

		const listener = (event: KeyboardEvent) => {
			switch (event.key) {
				case 'Esc':
				case 'Escape':
					onClose?.();
				default:
					return;
			}
		};
		document.body.addEventListener('keyup', listener);
		return () => {
			document.body.removeEventListener('keyup', listener);
		};
	}, [disableEscDismiss, onClose]);

	return (
		<div aria-labelledby='modal-title' aria-modal='true' className='fixed z-50 inset-0 overflow-y-auto' role='dialog'>
			<div className='flex items-end md:items-center justify-center min-h-screen md:pt-4 md:px-4 text-center sm:block sm:p-0'>
				<div
					aria-hidden='true'
					className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity'
					onClick={() => {
						onClose?.();
					}}
				/>
				<div
					className='inline-block align-bottom bg-white rounded-lg text-left shadow-xl transform transition-all sm:my-8 w-full sm:max-w-7xl'
					style={{ top: topOffset }}
				>
					{children}
				</div>
			</div>
		</div>
	);
};

Modal.displayName = 'UI.Modal';

export const ModalFooter: React.FunctionComponent = ({ children }) => (
	<div className='bg-gray-100 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse rounded-lg'>{children}</div>
);

ModalFooter.displayName = 'UI.ModalFooter';
